import { BroadcastMessage } from 'common/Enums'
import { store } from 'store'
import i18n from 'i18next'
import Webphone from './Webphone'
import { sendNotification } from './Helpers'
import { checkMultiTabsOpen, cleanupTabListeners, isCurrentTabPrime } from 'hooks'

class Broadcast {
    constructor() {
        return (Broadcast.instance = Broadcast.instance || this)
    }

    init() {
        this.bc = new BroadcastChannel('Kavkom_Webphone_Broadcast')
        this.bc.onmessage = this.onMessage.bind(this)
    }

    postMessage(message) {
        return message && this.bc.postMessage(message)
    }

    onMessage(event) {
        const { type } = event.data
        if (!type) return

        switch (type) {
            case BroadcastMessage.FocusActiveTab:
                this.sendFocusNotification()
                break
            case BroadcastMessage.ActiveTabFocused:
                this.onTabFocused()
                break
            case BroadcastMessage.TabRegistered:
                this.onTabRegistered()
                break
            case BroadcastMessage.PrimeTabChanged:
                this.onPrimeChanged()
                break
            default:
                break
        }
    }

    disconnect() {
        this.bc.close()
    }

    sendFocusNotification() {
        if (!store.getState().global.isMultipleTabs) {
            const onClick = () => {
                window.focus()
                this.postMessage({
                    type: BroadcastMessage.ActiveTabFocused,
                    payload: true
                })
            }

            sendNotification(i18n.t('notification.tab_focus'), i18n.t('notification.tab_focus_desc'), onClick)
        }
    }

    onTabFocused() {}

    onTabRegistered() {
        if (!isCurrentTabPrime()) {
            Webphone.unregistered()
            checkMultiTabsOpen()
        }
    }

    onPrimeChanged() {
        if (!isCurrentTabPrime()) {
            cleanupTabListeners()
        }
    }
}

export default new Broadcast()
